import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue-demi';
import {
  AbSection,
  AbContainer,
  AbTitle,
  AbDescription,
  AbButton,
  AbModal,
  AbVideo,
} from '../../../ui';
import FeatureSectionVideoTabsSlider from './FeatureSectionVideoTabsSlider.vue';
import FeatureSectionVideoTabsSliderMobile from './FeatureSectionVideoTabsSliderMobile.vue';
import { FeatureSectionVideoTabsSlideData } from '../../../../types';
import { Spacing } from '../../../../helpers/shared-props';

interface Props {
  id?: string;
  title?: string;
  text?: string;
  slides: FeatureSectionVideoTabsSlideData[];
  spacing?: Spacing;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionVideoTabs',
  props: {
    id: null,
    title: null,
    text: null,
    slides: null,
    spacing: null
  },
  setup(__props: any) {



const sliderNav = ref();
const activeSlide = ref(0);
const videoPlayer = ref();
const videoInModal = ref<null | string>(null);
const swiper = ref<any>();
const swiperMobile = ref<any>();

const playVideo = (videoId?: string) => {
  videoInModal.value = videoId ?? null;
  if (videoId) videoPlayer.value.open();
};

const closeVideo = () => {
  videoInModal.value = null;
};

const onSlideChange = (i: number) => {
  activeSlide.value = i;

  const nav = sliderNav.value as HTMLElement;
  const navButton = nav.children[i] as HTMLElement;

  nav.parentElement!.scroll({
    left: navButton.offsetLeft - navButton.offsetWidth,
  });
};

const changeSlide = (i: number) => {
  if (swiper.value && !swiper.value.destroyed) swiper.value.slideTo(i);

  if (swiperMobile.value && !swiperMobile.value.destroyed)
    swiperMobile.value.slideTo(i);
};

const onSwiperInit = (slider: any) => {
  swiper.value = slider;
  swiper.value?.on('activeIndexChange', () => {
    onSlideChange(swiper.value.activeIndex);
  });
};

const onSwiperMobileInit = (slider: any) => {
  swiperMobile.value = slider;
  swiperMobile.value?.on('activeIndexChange', () => {
    onSlideChange(swiperMobile.value.activeIndex);
  });
};

return { __sfc: true,sliderNav, activeSlide, videoPlayer, videoInModal, swiper, swiperMobile, playVideo, closeVideo, onSlideChange, changeSlide, onSwiperInit, onSwiperMobileInit, AbSection, AbContainer, AbTitle, AbDescription, AbButton, AbModal, AbVideo, FeatureSectionVideoTabsSlider, FeatureSectionVideoTabsSliderMobile }
}

})